export const PasswordValidator = (password: string): boolean => {
  const passwordRegex = /^(?!.*(012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210))(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,64}$/;
  return passwordRegex.test(password);
}
